import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';

export const baseURL =
    process.env.REACT_APP_ENV === 'prod'
        ? 'https://services.smartagent.app'
        : process.env.REACT_APP_ENV === 'beta'
            ? 'https://services.smartagent.app'
            : process.env.REACT_APP_ENV === 'uat'
                ? 'https://uat-services.smartagent.app'
                : 'https://dev-services.smartagent.app';

interface IMakeRequest {
    url: string;
    base?:string;
    data?: any;
    headers?: any;
    method?: 'get' | 'put' | 'post' | 'delete' | 'patch';
	params?: any;
	cancelToken?: any;
    ignoreToken?: boolean
}

export interface CustomAxiosConfig extends AxiosRequestConfig {
    ignoreToken?: boolean
}

interface CustomAxiosPromise<T = any> extends AxiosPromise<T> {
    config: CustomAxiosConfig
}

export function makeRequest<T = any>({ url, method = 'get', data, headers, params, cancelToken, base, ignoreToken = false }: IMakeRequest) {
    return axios({
        baseURL: base ?? baseURL,
        url,
        method,
        data,
        headers,
		params,
		cancelToken,
        ignoreToken
    } as CustomAxiosConfig ) as CustomAxiosPromise<T>;
}
